// Local fallback allowlist when getInit does not yet return
// `componentizationEligibleSkus` (older backends / failed bootup).
export const COMPONENTIZATION_ELIGIBLE_SKUS = [
  'PCD',
  'BIOM',
  'OGT',
  'OL',
  'FBI',
  'GI',
  'OHI',
];

/** Prefer getInit list when present; otherwise the local allowlist. */
export const resolveComponentizationEligibleSkus = (
  fromApi?: string[] | null,
): string[] =>
  fromApi != null ? fromApi : COMPONENTIZATION_ELIGIBLE_SKUS;
